import { all } from "@redux-saga/core/effects";
import { configManagerEntriesSagas } from "modules/ConfigManager/services/Entities/sagas";
import { initObjectStructures } from "modules/ConfigManager/services/initialization/sagas";
import { editCreateConfigSagas } from "modules/ConfigManager/services/CreateEditConfig/sagas";
import {siteGroupsSagas} from "modules/ConfigManager/services/SiteGroup/sagas";

export function* configManagerSaga() {
    yield all([
        initObjectStructures(),
        configManagerEntriesSagas(),
        editCreateConfigSagas(),
        siteGroupsSagas()
    ]);
}